export interface SupportFeedbackParams {
  rating: 'up' | 'down';
  note?: string;
  traceId?: string;
  houseId?: string;
  messageId?: string;
}

export async function submitSupportFeedback(params: SupportFeedbackParams): Promise<unknown> {
  const { callFunction } = await import('../firebase/FunctionsService');
  return callFunction('submitSupportFeedback', params);
}

export async function promoteTicketToKnowledge(params: {
  ticketId: string;
  houseId: string;
  title?: string;
  content: string;
}): Promise<unknown> {
  const { callFunction } = await import('../firebase/FunctionsService');
  return callFunction('promoteTicketToKnowledge', params);
}

export async function approveKnowledgeSource(params: { sourceId: string }): Promise<unknown> {
  const { callFunction } = await import('../firebase/FunctionsService');
  return callFunction('approveKnowledgeSource', params);
}

export async function setIntegrityDisposition(params: {
  runId: string;
  signalCode: string;
  houseId?: string;
  disposition: 'open' | 'tp' | 'fp' | 'suppressed';
  ticketId?: string;
}): Promise<unknown> {
  const { callFunction } = await import('../firebase/FunctionsService');
  return callFunction('setIntegrityDisposition', params);
}
